import {TextRegular} from '@hm/fundamental'
import React from 'react'

import {useTranslation} from '../../../../hooks/useTranslation'
import {DeleteConfirmationType} from '../TfaDialog'

export type DeleteTfaDialogContentProps = {
  showDeleteConfirmation?: DeleteConfirmationType
}
export const DeleteTfaDialogContent = ({showDeleteConfirmation}: DeleteTfaDialogContentProps) => {
  const {t} = useTranslation()

  return (
    <div className="flex flex-col">
      <TextRegular>
        {showDeleteConfirmation?.reason === 'delete'
          ? t('userInformationForm.tfa.delete.removeDescription')
          : t('userInformationForm.tfa.delete.replaceDescription')}
      </TextRegular>
    </div>
  )
}
